import { render, staticRenderFns } from "./newCheckTask.vue?vue&type=template&id=2a067814&scoped=true&"
import script from "./newCheckTask.vue?vue&type=script&lang=js&"
export * from "./newCheckTask.vue?vue&type=script&lang=js&"
import style0 from "./newCheckTask.vue?vue&type=style&index=0&id=2a067814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a067814",
  null
  
)

component.options.__file = "newCheckTask.vue"
export default component.exports